export default () => {

  $('.accordion-trigger').on('click', (e) => {
    e.preventDefault();
    $(e.currentTarget).toggleClass('-active')
      .parents('li')
      .toggleClass('-active')
      .find($('.accordion-content'))
      .slideToggle(250);
  });

};
